import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import capsuleImg from '../../../theme/assets/other/tc_cab_main_capsule.png';

import {fileSizeHandler, storageSizeHandler} from "../../../helpers/capsule";

const CabinetMainCapsule = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const dashboard = useSelector(store => store.cabinet.dashboard);

    const capsule = dashboard?.capsule;

    const rows = [
        {key: 'notes', name: t('Записей'), value: capsule?.notes_count || 0},
        {key: 'files', name: t('Файлов'), value: capsule?.files_count || 0},
        {key: 'memories', name: t('Воспоминаний'), value: capsule?.memories_count || 0},
        {
            key: 'storage',
            name: t('Объем'),
            // с API 16 у хранилища есть квота — показываем «занято из доступного»
            value: capsule?.storage_quota_bytes
                ? `${storageSizeHandler(capsule?.storage_bytes)} / ${storageSizeHandler(capsule?.storage_quota_bytes)}`
                : fileSizeHandler(capsule?.storage_bytes)
        }
    ];

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl}`}>
                    <div className={`${Styles.cardTitle}`}>{t('Моя капсула')}</div>

                    <div className={`${Styles.cardBody}`}>
                        <div className={`${Styles.capsuleImgWrap}`}>
                            <img src={capsuleImg} alt={t('Моя капсула')}/>
                        </div>

                        <div className={`${Styles.cardPos}`}>
                            <div className={`${Styles.cardNote}`}>
                                {t('Ваша личная капсула — это цифровое наследие и данные, которые останутся после вас.')}
                            </div>

                            <div className={`${Styles.statWrap}`}>
                                {rows.map((row, index)=>(
                                    <React.Fragment key={'cabinet-capsule-stat_' + row.key}>
                                        {index ? <div className={`${Styles.statDivider}`}/> : null}
                                        <div className={`${Styles.statRow}`}>
                                            <span className={`${Styles.statName}`}>{row.name}</span>
                                            <span className={`${Styles.statValue}`}>{row.value}</span>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>

                            <div
                                className={`${Styles.cardBtn}`}
                                onClick={()=>{navigate('/cabinet/capsule')}}
                            >
                                {t('Перейти в мою капсулу')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetMainCapsule;
